import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'
import {
  EMPTY_REFERENCE_BUNDLE,
  getReferenceBundle,
  APIReferenceBundle,
} from '@/services/notificationService'

const ReferenceContext = createContext<APIReferenceBundle>(
  EMPTY_REFERENCE_BUNDLE
)

export function ReferenceProvider({
  accountId,
  entityType = 'premise',
  children,
}: {
  accountId: string | number | undefined
  entityType?: string
  children: ReactNode
}) {
  const [bundle, setBundle] = useState<APIReferenceBundle>(
    EMPTY_REFERENCE_BUNDLE
  )

  useEffect(() => {
    if (!accountId) return
    getReferenceBundle(accountId, entityType)
      .then(setBundle)
      .catch(err => {
        console.error(
          '[ReferenceProvider] Failed to load reference bundle:',
          err
        )
      })
  }, [accountId, entityType])

  return (
    <ReferenceContext.Provider value={bundle}>
      {children}
    </ReferenceContext.Provider>
  )
}

export function useReference(): APIReferenceBundle {
  return useContext(ReferenceContext)
}
